import CrossMerchantAnalyticsDashboard from "../../features/cross-merchant-analytics/CrossMerchantAnalytics";

export default function CrossMerchantAnalyticsPage() {
  return <CrossMerchantAnalyticsDashboard />;
}

